import { FC } from 'react';
import { FilterOptions } from '@zoopla/redux-types/filters.types';

type OptionsProps = {
    options: FilterOptions;
    keyPrefix: string;
};

export const SelectRadiusOptions: FC<OptionsProps> = ({
    options,
    keyPrefix
}) => {
    return (
        // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {options?.map((option) => {
                if (!option) {
                    return null;
                }
                const { value, label } = option;

                const key = `${keyPrefix}-${value}`;

                return (
                    <option key={key} value={value}>
                        {label}
                    </option>
                );
            }) ?? []}
        </>
    );
};
